import { localDatabaseUrls } from "../backend/constants";
import { getAPI } from "../backend/commons";
import { getJWTToken } from "../shared/fetchWrapper/fetchWrapper";
import AlertManager from "../shared/Alert/Alert";

export const getRunDetailsHistory = async (batchId) => {
  const tokenInfo = await getJWTToken();
  if (!tokenInfo) {
    window.location.href = "/";
    return [];
  }

  const normalizedBatchId = batchId ?? "";
  const endpoint = localDatabaseUrls.serviceURL.runDetailsHistory;
  const apiUrl = `${localDatabaseUrls.baseURL}${endpoint}/${normalizedBatchId}`;

  try {
    const response = await getAPI(apiUrl, tokenInfo);
    if (response?.status === 200) {
      return response.json();
    }
    const error = await response?.json?.().catch(() => ({}));
    throw new Error(error?.message || "Unable to load run details history.");
  } catch (error) {
    AlertManager.error(error?.message || "Unable to load run details history.");
    return [];
  }
};

export default getRunDetailsHistory;
